<template>
  <svg
    width="81"
    height="80"
    viewBox="0 0 81 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_23021_55007)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.91188 39.4105C5.28469 41.0377 5.28469 43.6759 6.91188 45.3031L13.6845 52.0757C15.0424 51.3567 16.6857 50.8517 18.3566 50.6824C21.1095 50.4035 24.3892 50.9953 26.9466 53.5527C29.504 56.1101 30.0958 59.3897 29.8168 62.1426C29.6475 63.8136 29.1425 65.4568 28.4235 66.8147L35.1961 73.5874C36.8233 75.2145 39.4615 75.2145 41.0887 73.5874L74.087 40.589C75.7142 38.9619 75.7142 36.3237 74.087 34.6965L67.3144 27.9239C65.9565 28.6428 64.3132 29.1479 62.6423 29.3172C59.8894 29.5961 56.6097 29.0043 54.0523 26.4469C51.4949 23.8895 50.9031 20.6099 51.182 17.8569C51.3513 16.186 51.8564 14.5427 52.5754 13.1848L45.8027 6.41222C44.1756 4.78503 41.5374 4.78503 39.9102 6.41222L6.91188 39.4105ZM3.37634 48.8386C-0.203463 45.2588 -0.203463 39.4548 3.37634 35.875L36.3747 2.87668C39.9545 -0.703122 45.7585 -0.703122 49.3383 2.87668L57.5879 11.1263C58.5642 12.1026 58.5642 13.6855 57.5879 14.6618C57.1037 15.146 56.3388 16.5626 56.1566 18.361C55.9837 20.0667 56.374 21.6975 57.5879 22.9114C58.8017 24.1252 60.4325 24.5155 62.1383 24.3427C63.9366 24.1604 65.3533 23.3955 65.8374 22.9114C66.8137 21.9351 68.3967 21.9351 69.373 22.9114L77.6225 31.1609C81.2024 34.7408 81.2024 40.5448 77.6225 44.1246L44.6242 77.1229C41.0444 80.7027 35.2404 80.7027 31.6606 77.1229L23.411 68.8733C22.4347 67.897 22.4347 66.3141 23.411 65.3378C23.8952 64.8536 24.6601 63.437 24.8423 61.6386C25.0151 59.9329 24.6249 58.302 23.411 57.0882C22.1972 55.8744 20.5664 55.4841 18.8606 55.6569C17.0623 55.8391 15.6456 56.604 15.1615 57.0882C14.1851 58.0645 12.6022 58.0645 11.6259 57.0882L3.37634 48.8386Z"
        fill="#0081FF"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M40.4994 23.3577C41.8802 23.3577 42.9994 24.477 42.9994 25.8577V54.142C42.9994 55.5227 41.8802 56.642 40.4994 56.642C39.1187 56.642 37.9994 55.5227 37.9994 54.142V25.8577C37.9994 24.477 39.1187 23.3577 40.4994 23.3577Z"
        fill="#0081FF"
      />
      <path
        d="M55.2308 38.2321C56.2071 39.2084 56.2071 40.7913 55.2308 41.7676C54.2545 42.744 52.6716 42.744 51.6953 41.7676C50.7189 40.7913 50.7189 39.2084 51.6953 38.2321C52.6716 37.2558 54.2545 37.2558 55.2308 38.2321Z"
        fill="#0081FF"
      />
      <path
        d="M29.3035 38.2321C30.2799 39.2084 30.2799 40.7913 29.3035 41.7676C28.3272 42.744 26.7443 42.744 25.768 41.7676C24.7917 40.7913 24.7917 39.2084 25.768 38.2321C26.7443 37.2558 28.3272 37.2558 29.3035 38.2321Z"
        fill="#0081FF"
      />
    </g>
    <defs>
      <clipPath id="clip0_23021_55007">
        <rect
          width="80"
          height="80"
          fill="white"
          transform="translate(0.5)"
        />
      </clipPath>
    </defs>
  </svg>
</template>

<script setup lang="ts"></script>

<style scoped lang="scss"></style>
